import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import axios from "axios";
import DatetimePicker from "vuetify-datetime-picker";
import Chartkick from "vue-chartkick";
import Chart from "chart.js";
import * as VueGoogleMaps from "vue2-google-maps";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import FullCalendar from "vue-full-calendar";
import VueMeta from "vue-meta";
Vue.use(VueMeta);

Vue.use(FullCalendar);

Vue.use(VueToast, {
  position: "top-right",
});

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAhuli-g6uDvovKWVQSt4KaAfTEFRrHxMo",
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});

Vue.use(Chartkick.use(Chart));

// add these before Vue is instantiated
axios.defaults.baseURL = "https://api.baronitsolutions.co.za";

Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.use(DatetimePicker);

new Vue({
  vuetify,
  router,
  store,
  beforeCreate() {
    // if (localStorage.getItem("token")) {
    //   this.$store.dispatch("setCurrentUser", localStorage.getItem("token"));
    // }
  },
  render: (h) => h(App),
}).$mount("#app");
